import React from "react";

import {
  CheckCircleOutline,
  WarningAmberOutlined,
  ErrorOutlineOutlined,
} from "@mui/icons-material";
import { Alert, Typography, AlertColor, Skeleton } from "@mui/material";
import { fmtKPINumber } from "libLegacy/internal/format";

const AlertColors = {
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
};

const discountAlertData = (discount: number | undefined) => {
  const formatedDiscount = (discount ?? 0) * 100;
  let color: AlertColor;

  if (formatedDiscount >= 80) {
    color = "success";
  } else if (formatedDiscount > 50 && formatedDiscount < 80) {
    color = "warning";
  } else {
    color = "error";
  }

  return {
    value: fmtKPINumber(formatedDiscount, {
      onlyLargerThan: 99999999,
      decimals: 0,
      suffix: "%",
    }),
    color: color,
  };
};

const AlertIcon = ({ color }: { color: AlertColor }) => {
  switch (color) {
    case AlertColors.ERROR:
      return <ErrorOutlineOutlined />;
    case AlertColors.WARNING:
      return <WarningAmberOutlined />;
    default:
      return <CheckCircleOutline />;
  }
};

const alertText = ({ color, value }) => {
  switch (color) {
    case "error":
      return `O seu Sistema Solar fez você economizar em ${value} o seu gasto com o distribuidor de energia.`;
    case "warning":
      return `O seu Sistema Solar fez você economizar em ${value} o seu gasto com o distribuidor de energia.`;
    default:
      return `O seu Sistema Solar fez você economizar em ${value} o seu gasto com o distribuidor de energia.`;
  }
};

export const DiscountAlert: React.FC<DiscountAlertProps> = ({
  discount,
  isLoading,
}) => {
  const { value, color } = discountAlertData(discount);
  const texts = alertText({ color, value });

  return (
    <>
      {isLoading ? (
        <Skeleton variant="rectangular" height={70} />
      ) : (
        <Alert
          icon={<AlertIcon color={color} />}
          color={color}
          variant="outlined"
          sx={{ alignItems: "center" }}
        >
          <Typography variant="body1" color="text.primary" fontWeight={500}>
            {texts}
          </Typography>
        </Alert>
      )}
    </>
  );
};

export type DiscountAlertProps = {
  discount: number | undefined;
  isLoading: boolean | undefined;
};
